import { Stack } from "@mui/material";
import { LedgerTable } from "../components/Tables/LedgerTable";

export const ChartOfAccountDetails = () => {
  return (
    <Stack py={4}>
      <LedgerTable />
    </Stack>
  );
};
